import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";


interface Props {
    children: React.ReactNode;
    className?: string;
}

const StyledContainer = styled.div`
    max-width: ${({theme}) => theme.container.maxWidth};
    padding: ${({theme}) => theme.container.padding};
    margin: 0 auto;

`;


const Container: React.FC<Props> = ({children, className = ""}) => {
        return (
            <StyledContainer className={`${GLOBAL_STYLE_CONFIG.splitByPrefix('container')}  ${className}`}>
                {children}
            </StyledContainer>
        );
    }
;

export default Container;